<template>
  <div ref="mainDiv" style="height:fit-content;">
    <table :style="styleObject">
      <tr >
        <div class="header-title-ribbon" :style="headerStyleObj" style="background: white; color: black; display: flex;" >
                <span class="ribbon-left" ref="ribbonLeft" style="display: flex; align-items: flex-start; flex-wrap: wrap; overflow: hidden; flex-grow: 1;" >

                        <span
                            v-for="(item, index) in ribbonItems"
                            :key="item.id"
                            v-tooltip="{content: item.tooltip}"
                            :class="item.classObject"
                            class="ribbon-icon ribbon-icon-left item"
                            style="cursor: pointer;  padding: 9px 12px;"
                            :id="id + '_' + item.id"
                            :ref="'ribbon_icon_' + item.id"
                            :style="item.styleObject"
                            v-show="item.show"
                            :data-action="item.action"
                            @click="ribbonItemClick(item)"
                        ><span :class="item.fontClass"></span>
                        </span>
                </span>
          <span class="ribbon-right" style="display: flex;flex-direction: row-reverse; align-items: flex-start; flex-grow: 2;flex-wrap: nowrap;" >
            <span
                v-for="(item, index) in rightRibbonItems"
                :key="item.id"
                v-tooltip="{content: item.tooltip}"
                :class="item.classObject"
                class="ribbon-icon ribbon-icon-left item"
                style="cursor: pointer;  padding: 9px 12px;"
                :id="id + '_' + item.id"
                :style="item.styleObject"
                v-show="item.show"
                :data-action="item.action"
                @click="ribbonItemClick(item)"
            ><span :class="item.fontClass"></span>
                        </span>
          </span>
        </div>

      </tr>
      <tr>
        <td><div class="main-wrapper"><iframe ref="frame" @load="frameLoaded" style="height: 400px;" :src="documentURL"/> </div>
        </td>
      </tr>
    </table>
    <div style="display:none;" class="templates hidden">
      <div :id="id+'_drop-font'"> <strong>Change Font</strong> <i class="fas fa-times quit"></i>
        <br> Text Size:
        <select :id="id+'_textSelector'">
          <option data-size="12">Small</option>
          <option data-size="24">Medium</option>
          <option data-size="30">Large</option>
        </select>
        <br> Font:
        <select :id="id+'_fontSelect'">
          <option data-fonts="georgia">Georgia</option>
          <option data-fonts="arial">Arial</option>
          <option data-fonts="helvetica, arial">Helvetica</option>
          <option data-fonts="menlo, consolas, courier new, monospace">Monospace</option>
          <option data-fonts=" times new roman, times">Times New Roman</option>
          <option data-fonts="tahoma, sans-serif">Tahoma</option>
          <option data-fonts="trebuchet ms">Trebuchet MS</option>
          <option data-fonts="verdana">Verdana</option>
        </select>
        <br>
        <div class="dhx_button dhx_button--color_primary dhx_button--size_medium dhx_button--view_flat submitFont" style="display: inline-block; margin-top: 10px; float: right;">Apply</div>
      </div>
      <div :id="id+'_drop-font-color'"> <strong>Change Color</strong> <i class="fas fa-times quit"></i>
        <br> Color Hex:
        <br>
        <input placeholder="Color Hex" type="text" :id="id+'_colorhex'">
        <br> (Or) Select Color:
        <select :id="id+'_fontColorSelect'">
          <option class="White" data-color="White" style="background:White"> White </option>
          <option class="Silver" data-color="Silver" style="background:Silver"> Silver </option>
          <option class="Gray" data-color="Gray" style="background:Gray"> Gray </option>
          <option class="Black" data-color="Black" style="background:Black"> Black </option>
          <option class="red" data-color="red" style="background:red"> Red </option>
          <option class="Maroon" data-color="Maroon" style="background:Maroon"> Maroon </option>
          <option class="Yellow" data-color="Yellow" style="background:Yellow"> Yellow </option>
          <option class="Olive" data-color="Olive" style="background:Olive"> Olive </option>
          <option class="Lime" data-color="Lime" style="background:Lime"> Lime </option>
          <option class="green" data-color="green" style="background:green"> Green </option>
          <option class="Aqua" data-color="Aqua" style="background:Aqua"> Aqua </option>
          <option class="Teal" data-color="Teal" style="background:Teal"> Teal </option>
          <option class="Blue" data-color="Blue" style="background:Blue"> Blue </option>
          <option class="Navy" data-color="Navy" style="background:Navy"> Navy </option>
          <option class="Fuchsia" data-color="Fuchsia" style="background:Fuchsia"> Fuchsia </option>
          <option class="Purple" data-color="Purple" style="background:Purple"> Purple </option>
        </select>
        <br>
        <div class="dhx_button dhx_button--color_primary dhx_button--size_medium dhx_button--view_flat submitFontColor" style="display: inline-block; margin-top: 10px; float: right;">Apply</div>
      </div>
      <div :id="id+'_drop-highlight-color'"> <strong>Change Highlight</strong> <i class="fas fa-times quit"></i>
        <br> Highlight Color Hex:
        <br>
        <input placeholder="Highlight Hex" type="text" :id="id+'_highlightHex'">
        <br> (Or) Select Color:
        <select :id="id+'_highlightColorSelect'">
          <option class="White" data-color="White" style="background:White"> White </option>
          <option class="Silver" data-color="Silver" style="background:Silver"> Silver </option>
          <option class="Gray" data-color="Gray" style="background:Gray"> Gray </option>
          <option class="Black" data-color="Black" style="background:Black"> Black </option>
          <option class="red" data-color="red" style="background:red"> Red </option>
          <option class="Maroon" data-color="Maroon" style="background:Maroon"> Maroon </option>
          <option class="Yellow" data-color="Yellow" style="background:Yellow"> Yellow </option>
          <option class="Olive" data-color="Olive" style="background:Olive"> Olive </option>
          <option class="Lime" data-color="Lime" style="background:Lime"> Lime </option>
          <option class="green" data-color="green" style="background:green"> Green </option>
          <option class="Aqua" data-color="Aqua" style="background:Aqua"> Aqua </option>
          <option class="Teal" data-color="Teal" style="background:Teal"> Teal </option>
          <option class="Blue" data-color="Blue" style="background:Blue"> Blue </option>
          <option class="Navy" data-color="Navy" style="background:Navy"> Navy </option>
          <option class="Fuchsia" data-color="Fuchsia" style="background:Fuchsia"> Fuchsia </option>
          <option class="Purple" data-color="Purple" style="background:Purple"> Purple </option>
        </select>
        <br>
        <div class="dhx_button dhx_button--color_primary dhx_button--size_medium dhx_button--view_flat submitHighlightColor" style="display: inline-block; margin-top: 10px; float: right;">Apply</div>
      </div>
      <div :id="id+'_drop-link'"> <strong>Insert Link</strong> <i class="fas fa-times quit"></i>
        <br>
        <input style="padding:10px 0px;" placeholder="Link URL" type="text" :id="id+'_url'">
        <br>
        <div class="dhx_button dhx_button--color_primary dhx_button--size_medium dhx_button--view_flat submitLink" style="display: inline-block; margin-top: 10px; float: right;">Insert</div>
      </div>
      <div :id="id+'_drop-image'"> <strong>Insert Image</strong> <i class="fas fa-times quit"></i>
        <br>
        <input placeholder="Image URL" type="text" :id="id+'_imageUrl'">
        <br>
        <div class="dhx_button dhx_button--color_primary dhx_button--size_medium dhx_button--view_flat sumbitImageURL" style="display: inline-block; margin-top: 10px; float: right;">Insert</div>
      </div>
      <div :id="id+'_drop-button'"> <strong>Insert Button</strong> <i class="fas fa-times quit"></i>
        <br>
        <input style="padding:10px 0px;" placeholder="Button Text" type="text" :id="id+'_button_text'">
        <br>
        <input style="padding:10px 0px;" placeholder="Function Name" type="text" :id="id+'_button_function_name'">
        <br>
        <input style="padding:10px 0px;" placeholder="Params" type="text" :id="id+'_button_fn_params'">
        <br>
        <div class="dhx_button dhx_button--color_primary dhx_button--size_medium dhx_button--view_flat submitButton" style="display: inline-block; margin-top: 10px; float: right;">Insert</div>
      </div>
      <div :id="id+'_form-item'"> <strong>Insert Form Item</strong> <i class="fas fa-times quit"></i>
        <br>
        <input style="padding:10px 0px;" placeholder="Field Name" type="text" :id="id+'_form_field_name'">
        <br>
        <input style="padding:10px 0px;" placeholder="Label" type="text" :id="id+'_form_item_label'">
        <br>
        <select :id="id+'_form_item_type'">
          <option value="text">text</option>
          <option value="password">password</option>
          <option value="select">select</option>
        </select>
        <br>
        <input style="padding:10px 0px;" placeholder="Placeholder" type="text" :id="id+'_form_item_placeholder'">
        <br>
        <input style="padding:10px 0px;" placeholder="Add Select Value" type="text" :id="id+'_form_item_select_value'">
        <br>
        <select :id="id+'_form_item_select_values'" style="">
          <option value=""></option>
        </select>
        <div>

          <span class="dhx_button dhx_button--color_primary dhx_button--size_small dhx_button--view_flat submitRemoveSelectValue" style="display: inline-block; margin-top: 10px; float: right;">Remove</span>
          <span class="dhx_button dhx_button--color_primary dhx_button--size_small dhx_button--view_flat submitAddSelectValue" style="display: inline-block; margin-right:5px; margin-left:5px; margin-top: 10px; float: right;">Add</span>
        </div>
        <br>
        <div class="dhx_button dhx_button--color_primary dhx_button--size_medium dhx_button--view_flat submitFormItem" style="display: inline-block; margin-top: 10px; float: right;">Insert</div>
      </div>
    </div>
  </div>
  <form-container
      :title="formContainerTitle"
      :form-rows="formRows"
      ref="formContainer"
  ></form-container>
  <multiple-forms-container
      :title="multipleFormsContainerTitle"
      :viewport-i-d="dataViewportid"
      :client-i-d="client.Client"
      :form-rows="multipleFormsRows"
      :buttons="multipleFormsButtons"
      :form-width="multipleFormsWidth"
      :initial-form-data="initialMultipleFormsData"
      :allow-new="multipleFormsAllowNew"
      ref="multipleFormsContainer"
  ></multiple-forms-container>
</template>

<script>
import * as oxygenUtil from './../OxygenUtil/oxygenutil.js';
import $ from 'jquery';
import * as async from 'async-es';
import { vTooltip } from 'floating-vue';
import MultipleFormsContainer from './../MultipleFormsContainer/MultipleFormsContainer.vue';
import FormContainer from './../FormContainer/FormContainer.vue';

export default {
  directives: {
    tooltip: vTooltip
  },
  components: {
    MultipleFormsContainer,
    FormContainer
  },
  props: {
    dataViewportid: String,
    embedMode: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      formContainerTitle: '',
      multipleFormsContainerTitle: '',
      lastSelectedContentTemplate: '',
      formRows: [],
      multipleFormsRows: [],
      multipleFormsButtons: [],
      multipleFormsAllowNew: false,
      initialMultipleFormsData: [],
      currentMessageTemplates: [],
      multipleFormsWidth: 400,
      readonly: false,
      documentURL: '',
      id: `id${oxygenUtil.getUUID()}`,
      ribbonItems: [
        { id: 'bold', classObject: {}, styleObject: {}, tooltip: 'Bold', tooltipShow: false, show: true, fontClass: 'far fa-bold', action: 'bold' },
        { id: 'italic', classObject: {}, styleObject: {}, tooltip: 'Italic', tooltipShow: false, show: true, fontClass: 'far fa-italic', action: 'italic' },
        { id: 'underline', classObject: {}, styleObject: {}, tooltip: 'Underline', tooltipShow: false, show: true, fontClass: 'far fa-underline', action: 'underline' },
        { id: 'selectFont', classObject: {'drop-target': true}, styleObject: {}, tooltip: 'Select Font', tooltipShow: false, show: true, fontClass: 'far fa-font', action: 'selectFont' },
        { id: 'setTextColour', classObject: {'drop-target': true}, styleObject: {}, tooltip: 'Color', tooltipShow: false, show: true, fontClass: 'far  fa-eye-dropper', action: 'setTextColour' },
        { id: 'setHighlightColour', classObject: {'drop-target': true}, styleObject: {}, tooltip: 'Highlight Color', tooltipShow: false, show: true, fontClass: 'far fa-paint-brush', action: 'setHighlightColour' },
        { id: 'makeButton', classObject: {'drop-target': true}, styleObject: {}, tooltip: 'Add Button', tooltipShow: false, show: true, fontClass: 'far fa-square-arrow-up-right', action: 'makeButton' },
        { id: 'makeFormItem', classObject: {'drop-target': true}, styleObject: {}, tooltip: 'Add Form Item', tooltipShow: false, show: true, fontClass: 'far fa-input-text', action: 'makeFormItem' },
        { id: 'saveMessage', classObject: {}, styleObject: {}, tooltip: 'Save Message', tooltipShow: false, show: true, fontClass: 'far fa-floppy-disk', action: 'saveMessage' },
        { id: 'loadMessage', classObject: {}, styleObject: {}, tooltip: 'Load Message', tooltipShow: false, show: true, fontClass: 'far fa-upload', action: 'loadMessage' },

        { id: 'makeLink', classObject: {'drop-target': true}, styleObject: {}, tooltip: 'Add Link', tooltipShow: false, show: true, fontClass: 'far fa-link', action: 'makeLink' },

        { id: 'makeOrderedList', classObject: {}, styleObject: {}, tooltip: 'Ordered List', tooltipShow: false, show: true, fontClass: 'far fa-list-ol', action: 'makeOrderedList' },
        { id: 'makeUnorderedList', classObject: {}, styleObject: {}, tooltip: 'Unordered List', tooltipShow: false, show: true, fontClass: 'far fa-list-ul', action: 'makeUnorderedList' },
//{ id: 'insertImage', classObject: {'drop-target': true}, styleObject: {}, tooltip: 'Insert Image', tooltipShow: false, show: true, fontClass: 'far fa-image', action: 'insertImage' },
        { id: 'insertImage', classObject: {}, styleObject: {}, tooltip: 'Insert Image', tooltipShow: false, show: true, fontClass: 'far fa-image', action: 'insertImage' },
        { id: 'increaseQuoteLevel', classObject: {}, styleObject: {}, tooltip: 'Increase Quote', tooltipShow: false, show: true, fontClass: 'far fa-quote-right', action: 'increaseQuoteLevel' },
        { id: 'addAttachment', classObject: {'add-attachment': true}, styleObject: {}, tooltip: 'Add Attachment', tooltipShow: false, show: true, fontClass: 'far fa-paperclip', action: 'addAttachment' },
        { id: 'makeHeading', classObject: {}, styleObject: {}, tooltip: 'Heading', tooltipShow: false, show: true, fontClass: 'far fa-heading', action: 'makeHeading' },
        { id: 'alignLeft', classObject: {}, styleObject: {}, tooltip: 'Align Left', tooltipShow: false, show: true, fontClass: 'far fa-align-left', action: 'alignLeft' },
        { id: 'alignCenter', classObject: {}, styleObject: {}, tooltip: 'Align Center', tooltipShow: false, show: true, fontClass: 'far fa-align-center', action: 'alignCenter' },
        { id: 'alignRight', classObject: {}, styleObject: {}, tooltip: 'Align Right', tooltipShow: false, show: true, fontClass: 'far fa-align-right', action: 'alignRight' },
        { id: 'undo', classObject: {}, styleObject: {}, tooltip: 'Undo', tooltipShow: false, show: true, fontClass: 'far fa-undo', action: 'undo' },
        { id: 'redo', classObject: {}, styleObject: {}, tooltip: 'Redo', tooltipShow: false, show: true, fontClass: 'far fa-redo', action: 'redo' },
        { id: 'upload', classObject: {}, styleObject: {}, tooltip: 'Upload', tooltipShow: false, show: true, fontClass: 'far fa-upload', action: 'upload' },
        { id: 'removeAllFormatting', classObject: {}, styleObject: {}, tooltip: 'Remove Formatting', tooltipShow: false, show: true, fontClass: 'far fa-times', action: 'removeAllFormatting' }
      ],
      rightRibbonItems: [
        { id: 'expand', classObject: {}, styleObject: {}, tooltip: 'Expand', tooltipShow: false, show: true, fontClass: 'far fa-angle-double-down', action: 'expand' },
        { id: 'collapse', classObject: {}, styleObject: {}, tooltip: 'Collapse', tooltipShow: false, show: false, fontClass: 'far fa-angle-double-up', action: 'collapse' },

      ],
      triggerType: 'hover',
      headerStyleObj: {
        'height': '39px',
        'font-size': '1em',
        'border-top': '1px solid lightgrey'
      },
      rowStyleObject: {
        'height': '39px'
      },
      //editorData: this.editorData,
      //componentData: this.componentData,
      styleObject: {'table-layout': 'fixed', 'width': '100%'},
      injectSquire: false,
      //parent: this,
      iconIds: {
        bold: "_FFFFFFFFFFFFFF00001635352627301293_",
        italic: "_FFFFFFFFFFFFFF00001635352627301294_",
        underline: "_FFFFFFFFFFFFFF00001635352627301295_",
        font: "_FFFFFFFFFFFFFF00001635352627301296_",
        color: "_FFFFFFFFFFFFFF00001635352627301297_",
        highlightColor: "_FFFFFFFFFFFFFF00001635352627301299_",
        link: "_FFFFFFFFFFFFFF00001635352627301300_",
        orderedList: "_FFFFFFFFFFFFFF00001635352627301301_",
        unorderedList: "_FFFFFFFFFFFFFF00001635352627301302_",
        image: "_FFFFFFFFFFFFFF00001635352627301303_",
        quote: "_FFFFFFFFFFFFFF00001635352627301304_",
        attachment: "_FFFFFFFFFFFFFF00001635352627301306_",
        heading: "_FFFFFFFFFFFFFF00001635352627301307_",
        alignLeft: "_FFFFFFFFFFFFFF00001635352627301308_",
        alignCenter: "_FFFFFFFFFFFFFF00001635352627301309_",
        alignRight: "_FFFFFFFFFFFFFF00001635352627301310_",
        undo: "_FFFFFFFFFFFFFF00001635352627301311_",
        redo: "_FFFFFFFFFFFFFF00001635352627301312_",
        upload: "_FFFFFFFFFFFFFF00001635352627301313_",
        removeFormatting: "_FFFFFFFFFFFFFF00001635352627301314_"
      }
    }
  },
  mounted() {
    //that.frameContainer = this;
    /*
    that.editor = new Squire(this.$el.querySelector('.squire_editor'), {});
    //that.debugLog('createSquireEditor-mounted:', 'editor:', that.editor);
    setTimeout((function () {
    that.setupSquireListeners();
    that.editor.setHTML(that.atComponent.InitialContext.SquireContent || '');
    }), 1000);
    */
    if(this.viewport) {
      oxygenUtil.addTemplateSaveOptions(this.viewport.viewportID, async (initialContext)=>{
        initialContext.SquireContent = this.editor.getHTML();
      })
    }
    if(!this.embedMode) {
      this.hideRightRibbonItem('loadMessage');
      this.hideRightRibbonItem('saveMessage');
    }
  },
  computed: {
    contextPE() {
      return this.client ?
          ( (window.LivingScript_0070.context.credentialId === this.client.ClientRight) ?
              ( oxygenUtil.createSimpleOES(['admin', this.client.ClientRight, 'admin', this.client.ClientRight]) ):
              oxygenUtil.createSimpleOES([this.client.ClientLeftRole, this.client.ClientLeft, this.client.ClientRightRole, this.client.ClientRight]) ):
          oxygenUtil.createSimpleOES(['admin', '_FFFFFFFFFFFFFF00001567723986493004_', 'admin', '_FFFFFFFFFFFFFF00001567723986493004_']);
    },
    viewport() {
      return window.devStore.viewPorts.find(e => e.viewportID === this.dataViewportid);
    },
    isShadowRoot() {
      return !this.embedMode;
    },
    rootElement() {
      if(this.isShadowRoot) {
        return document.querySelector(`squire-component[data-viewportid="${this.dataViewportid}"]`).shadowRoot
      }
      else {
        return this.$refs.mainDiv;
      }
    },
    client() {
      return window.devStore.clients.find(e => e.Client === this.viewport.ClientID);
    },
    clientInitialContext() {
      let context;
      if(this.client.InitialContext && (context = oxygenUtil.tryParseJSON(this.client.InitialContext))) {
        return context;
      }
      return null;
    },
    byClient() {
      if(this.clientInitialContext && this.clientInitialContext.ByClientID) {
        return window.devStore.clients.find(e => this.clientInitialContext.ByClientID === e.Client);
      }
      return null;
    }
  },
  created() {
    //window._squireComp = this;
    this.createScriptTag('/simplia/serverfilepath/Code/github/SimpliaV2Components/SquireComponent/assets/drop.js');
    setTimeout(async()=>{
      if(this.dataViewportid) {
        this.atComponent = await oxygenUtil.getComponent(this.client.ClientRight);
        console.log('created', 'atComponent:', this.atComponent);
        this.readonly = !this.embedMode && (this.atComponent.MetaType === 'Tip');
      }
      //this.documentURL = `/simplia/serverfilepath/Code/github/SimpliaV2Components/SquireComponent/assets/document${this.readonly ? '-readonly': ''}.html`;
      this.documentURL = `/simplia/dist/htm/document${this.readonly ? '-readonly': ''}.html`;
    },0);
  },
  methods: {
    getElement(id) {
      if(!this.isShadowRoot) {
        return document.getElementById(id);
      }
      else {
        return document.querySelector(`squire-component[data-viewportid="${this.dataViewportid}"]`).shadowRoot.getElementById(id);
      }
    },
    createScriptTag(url) {
      const scriptTag = document.createElement('script');
      scriptTag.src = url;
      scriptTag.setAttribute('charset', 'utf-8');
      document.head.appendChild(scriptTag)
    },
    async saveMessage() {
      this.formContainerTitle = "Save Message Template";
      this.formRows.length = 0;

      this.formRows.push(
          {
            type: "input",
            name: "templateName",
            label: "Name",
            value: ''
          },
          {
            type: "button",
            css: "spaced-button",
            name: "saveTemplate",
            text: "Save",
            size: "medium",
            view: "flat",
            color: "primary"
          }
      );
      this.$refs.formContainer.showContainerAlignedToElementInViewport(
          window.top.document.getElementById(this.dataViewportid).querySelector(".main-panel-header-title"),
          'bottom',
          window.top.document.getElementById(this.dataViewportid).getBoundingClientRect()
      );

      await this.$nextTick();
      this.$refs.formContainer.formInstance.getItem("saveTemplate").events.on("click", async ()=>{
        let templateName = this.$refs.formContainer.formInstance.getItem("templateName").getValue();
        await oxygenUtil.runDBQuery(
            `insert into OxygenDatabase.MessageTemplates (TemplateName, TemplateText, ContextPE, MetaType) values(?,?,?,?)`,
            [templateName, this.editor.getHTML(), this.contextPE, 'Html']
        );
        this.$refs.formContainer.hide();
      });
    },
    async showSavedMessagesList() {
      this.multipleFormsContainerTitle = "Saved Messages";
      this.multipleFormsRows.length = 0;

      this.multipleFormsRows.push(
          {
            type: "input",
            name: "TemplateName",
            label: "Name",
            readOnly: true,
            value: ''
          },
          {
            type: "container",
            name: "TemplateText",
            label: "Message",
            readOnly: true,
            height: 300
          }
      );

      let data = await oxygenUtil.callCommonServiceAPI("simplia-api","getMessageTemplates", { ClientId:  this.client.Client, MetaType: 'Html' });


      this.initialMultipleFormsData.length = 0;


      this.initialMultipleFormsData.push( ...((this.currentMessageTemplates = data.results).map((e) => {
        return { TemplateText: e.TemplateText, TemplateName: e.TemplateName }
      })));

      this.multipleFormsButtons.length = 0;
      this.multipleFormsButtons.push(
          { id: 'hide', html: 'Hide', callback: ()=>{
              this.$refs.multipleFormsContainer.hide();
            }, disabled: false, show: true, orientation: 'right', style: { 'background-color': '#0072C5', 'color': 'white'}},
          { id: 'use', html: 'Use', callback: ()=>{
              /*console.log('use-callback', 'templateTextItem:',  this.$refs.multipleFormsContainer.formInstance.getItem('TemplateText'),
              'val:', this.$refs.multipleFormsContainer.formInstance.getItem('TemplateText').getValue());*/
              console.log('Use-callback', 'item:',this.$refs.multipleFormsContainer.formInstance.getItem('TemplateText'));
              this.editor.setHTML(this.$refs.multipleFormsContainer.formInstance.getItem('TemplateText').container.config.html);
              this.$refs.multipleFormsContainer.hide();
            }, disabled: false, show: true, orientation: 'right', style: { 'background-color': '#0072C5', 'color': 'white'}},
      );

      this.$refs.multipleFormsContainer.showContainerAlignedToElementInViewport(
          window.top.document.getElementById(this.dataViewportid).querySelector(".main-panel-header-title"),
          'bottom',
          window.top.document.getElementById(this.dataViewportid).getBoundingClientRect()
      );
      await this.$nextTick();
      window.top.document.getElementById(this.dataViewportid).querySelector(".main-panel-header-title").focus();
    },
    showLeftRibbonItem(id) {
      this.ribbonItems.find(e => (e.id === id)).show = true;
    },
    hideLeftRibbonItem(id) {
      this.ribbonItems.find(e => (e.id === id)).show = false;
    },
    showRightRibbonItem(id) {
      this.rightRibbonItems.find(e => (e.id === id)).show = true;
    },
    hideRightRibbonItem(id) {
      this.rightRibbonItems.find(e => (e.id === id)).show = false;
    },
    ribbonItemClick(item, ev) {
      let fn = {
        'expand': ()=>{
          this.expandRibbon(ev);
          this.showRightRibbonItem('collapse');
          this.hideRightRibbonItem('expand');
        },
        'collapse': ()=>{
          this.headerStyleObj.height = '39px';
          this.hideRightRibbonItem('collapse');
          this.showRightRibbonItem('expand');
        },
        'saveMessage': async ()=>{
          await this.saveMessage()
        },
        'loadMessage': async ()=>{
          await this.showSavedMessagesList();
        }
      }
      if(typeof fn[item.id] !== "undefined") {
        fn[item.id]();
      }
    },
    expandRibbon(ev) {

        let totalIconsWidth = this.ribbonItems.filter(e => e.show).reduce((acc, cur)=>{

          window.top.__squire_c = this;
          //console.log('expandRibbon', 'id:', cur.id, ' - width:', parseInt(getComputedStyle(this.$refs[`ribbon_icon_${cur.id}`][0]).width));
          return acc += this.$refs[`ribbon_icon_${cur.id}`][0].offsetWidth;
        },0);
        console.log('expandRibbon', 'total:', totalIconsWidth);
        //this.debugLog('expandRibbon', 'totalIconsWidth:', totalIconsWidth);
        //this.debugLog('expandRibbon', 'ribbonWidth:', $(this.windowHeader.ribbon.mainElement).find('.ribbon-left').innerWidth());
        let numOfExtraRows = Math.ceil(totalIconsWidth / this.$refs.ribbonLeft.offsetWidth);
      console.log('expandRibbon', 'rows:', numOfExtraRows);
        //this.debugLog('expandRibbon', 'numOfExtraRows:', numOfExtraRows);
      this.headerStyleObj.height = `${39 * numOfExtraRows}px`;


    },
    frameLoaded() {
      //that.debugLog('frameLoaded', 'called');
      //that.editorFrame = this.$refs.frame;
      //that.debugLog('frameLoaded', 'contentDocument:', this.$refs.frame.contentDocument);
      if ( this.$refs.frame && this.$refs.frame.contentDocument ) {
// get and check the Title (and H tags if you want)
        //that.debugLog('frameLoaded', 'tile:', this.$refs.frame.contentDocument.title);
        let ifTitle = this.$refs.frame.contentDocument.title || '';
        if ( ifTitle.indexOf("404")>=0 ) {
          setTimeout(()=>{
            this.$refs.frame.contentWindow.location.reload();
          },500);
        }
        else {
          $( this.$refs.frame.contentDocument.body).css({'position':'relative', 'overflow':'auto'});
          /*if(this.injectSquire) {
            that.injectSquireInIframe((editor)=>{
              that.editor = editor;
              that.setupSquireListeners();
              this.injectSquire = false;
            });
          }*/
          //else {
          this.setupSquire()
          //}
        }
      }
      else {

      }
    },
    setupSquire() {
      this.editor = this.$refs.frame.contentWindow.editor;

      let interval = setInterval((()=> {
        if($(`#${this.id}_drop-font`, this.rootElement)[0] && window.Drop) {
          //that.debugLog('setupSquire', 'setting listeners');
          this.setupSquireListeners();
          if(this.atComponent && this.atComponent.InitalContext) {
            this.editor.setHTML(this.atComponent.InitialContext.SquireContent || '');
          }

          clearInterval(interval);
        }

      }), 1000);
    },
    setupSquireListeners() {
      var that = this;

      //this.iframePS = new PerfectScrollbar(this.editorFrame.contentDocument.body);

      this.$refs.frame.contentWindow.Squire.prototype.testPresenceinSelection = function (name, action, format,
                                                                                          validation) {
        var path = this.getPath(),
            test = (validation.test(path) | this.hasFormat(format));
        if (name == action && test) {
          return true;
        } else {
          return false;
        }
      };

      let editor = this.editor;

      //this.debugLog('setupSquireListeners', 'linkEl:',this.getElement(`${this.id}_makeLink`))
      this.linkDrop = new Drop({
        //target: document.$(`#${this.id}_makeLink`).first()[0],
        target: this.getElement(`${this.id}_makeLink`),
        content: $(`#${this.id}_drop-link`, this.rootElement).html(),
        position: 'bottom center',
        openOn: 'click'
      });

      this.linkDropClickHandler = false;
      this.linkDrop.on('open', function () {
        that.fixDropLocation(that.linkDrop);

        $('.quit', this.rootElement).click(function () {
          $(this).parent().parent().removeClass('drop-open');
        });

        if(!this.linkDropClickHandler) {
          this.linkDropClickHandler = true;
          $('.submitLink', this.rootElement).click(function () {
            editor.makeLink($(this).parent().children(`#${that.id}_url`).first().val());
            $(this).parent().children(`#${that.id}_url`).first().val('')
            $(this).parent().parent().removeClass('drop-open');
            $(this).parent().children(`#${that.id}_url`).attr('value', '');
          });
        }


      });

      this.buttonDrop = new Drop({

        target: this.getElement(`${this.id}_makeButton`),
        content: $(`#${this.id}_drop-button`, this.rootElement).html(),
        position: 'bottom center',
        openOn: 'click'
      });


      this.makeButtonClickHandler = false;
      this.buttonDrop.on('open', function () {
        that.fixDropLocation(that.buttonDrop);

        $('.quit', this.rootElement).click(function () {
          $(this).parent().parent().removeClass('drop-open');
        });

        if(!this.makeButtonClickHandler) {
          this.makeButtonClickHandler = true;
          $('.submitButton', this.rootElement).click(function () {
            editor.makeButton(
                $(this).parent().children(`#${that.id}_button_text`).first().val(),
                $(this).parent().children(`#${that.id}_button_function_name`).first().val(),
                $(this).parent().children(`#${that.id}_button_fn_params`).first().val()
            );
            $(this).parent().children(`#${that.id}_button_text`).first().val('');
            $(this).parent().children(`#${that.id}_button_function_name`).first().val('');
            $(this).parent().children(`#${that.id}_button_fn_params`).first().val('');
            $(this).parent().parent().removeClass('drop-open');
            $(this).parent().children(`#${that.id}_url`).attr('value', '');
          });

        }

      });

      this.formItemDrop = new Drop({

        target: this.getElement(`${this.id}_makeFormItem`),
        content: $(`#${this.id}_form-item`, this.rootElement).html(),
        position: 'bottom center',
        openOn: 'click'
      });

      window._squire_c = editor;

      this.submitFormItemClickHandlers = false;
      this.formItemDrop.on('open', function () {
        that.fixDropLocation(that.formItemDrop);

        $('.quit', this.rootElement).click(function () {
          $(this).parent().parent().removeClass('drop-open');
        });

        if(!this.submitFormItemClickHandlers) {
          this.submitFormItemClickHandlers = true;
          $('.submitFormItem', this.rootElement).click(function () {
            console.log('calling makeFormItem');
            editor.makeFormItem(
                $(this).parent().children(`#${that.id}_form_item_label`).first().val(),
                $(this).parent().children(`#${that.id}_form_field_name`).first().val(),
                $(this).parent().children(`#${that.id}_form_item_type`).first().val(),
                $(this).parent().children(`#${that.id}_form_item_placeholder`).first().val(),
                $(this).parent().children(`#${that.id}_form_item_select_values`).first().html()
            );

            $(this).parent().children(`#${that.id}_form_field_name`).first().val('')
            $(this).parent().children(`#${that.id}_form_item_label`).first().val('');
            $(this).parent().children(`#${that.id}_form_item_placeholder`).first().val('');
            $(this).parent().parent().removeClass('drop-open');

          });

          $('.submitAddSelectValue', this.rootElement).click(function(){
            let val = $(this).parent().parent().children(`#${that.id}_form_item_select_value`).first().val();
            console.log('click:', 'val:', val);
            if(val) {
              $(this).parent().parent().children(`#${that.id}_form_item_select_values`).append($('<option>', {
                value: val,
                text: val
              }));
            }
          });

          $('.submitRemoveSelectValue', this.rootElement).click(function(){
            let val =  $(this).parent().parent().children(`#${that.id}_form_item_select_values`).first().val();
            console.log('remove', 'val:', val);
            console.log('remove', 'option:', $(this).parent().parent().children(`#${that.id}_form_item_select_values option[value='${val}']`));
            $(this).parent().parent().children(`#${that.id}_form_item_select_values option`).each(function() {
              console.log('remove', 'opt:', $(this));
              $(this).remove();
            });

          });
        }




      });
      /*
      this.imageDrop = new Drop({
          target: $(`#${this.id}_insertImage`).first()[0],
          content: $(`#${this.id}_drop-image`).html(),
          position: 'bottom center',
          openOn: 'click'
      });

      this.imageDrop.on('open', function () {
          $(that.imageDrop.content).parent().css('z-index', 9999);
          $('.quit').unbind().click(function () {
              $(this).parent().parent().removeClass('drop-open');
          });

          $('.sumbitImageURL').unbind().click(function () {
              console.log("Passed through .sumbitImageURL");
              var url = $(this).parent().children(`#${that.id}_imageUrl`).first()[0];
              editor.insertImage(url.value);
              $(this).parent().parent().removeClass('drop-open');
              $(this).parent().children(`#${that.id}_imageUrl`).attr('value', '');
          });

      });

       */

      this.fontDrop = new Drop({
        target: this.getElement(`${this.id}_selectFont`),
        //target: $(`#${this.id}_selectFont`).first()[0],
        //content: this.getElement(`${this.id}_drop-font`),
        content: $(`#${this.id}_drop-font`, this.rootElement).html(),
        position: 'bottom center',
        openOn: 'click'
      });

      this.fontDrop.on('open', function () {
        that.fixDropLocation(that.fontDrop);
        $('.quit', this.rootElement).click(function () {
          $(this).parent().parent().removeClass('drop-open');
        });

        $('.submitFont', this.rootElement).unbind().click(function () {
          var selectedFonts = $(`select#${that.id}_fontSelect option:selected`, this.rootElement).last().data('fonts');
          var fontSize = $(`select#${that.id}_textSelector option:selected`, this.rootElement).last().data('size') + 'px';
          editor.setFontSize(fontSize);

          try {
            editor.setFontFace(selectedFonts);
          } catch (e) {
            alert('Please make a selection of text.');
          } finally {
            $(this).parent().parent().removeClass('drop-open');
          }

        });
      });

      //this.debugLog('setupSquireListeners', 'setTextColorEl:',`${this.id}_setTextColour`);
      this.fontColorDrop = new Drop({
        target: this.getElement(`${this.id}_setTextColour`),
        //target: $(`#${this.id}_setTextColour`).first()[0],
        content: $(`#${this.id}_drop-font-color`, this.rootElement).html(),
        position: 'bottom center',
        openOn: 'click'
      });

      this.fontColorDrop.on('open', function () {
        //$(that.fontColorDrop.content).parent().css('z-index', 9999);
        that.fixDropLocation(that.fontColorDrop);
        $('.quit', this.rootElement).click(function () {
          $(this).parent().parent().removeClass('drop-open');
        });

        $('.submitFontColor', this.rootElement).unbind().click(function () {
          var colorHex = $(this).parent().children(`#${that.id}_colorhex`).first()[0].value;
          var selectedFontColor = $(`select#${that.id}_fontColorSelect option:selected`).last().data('color');
          console.log($(`select#${that.id}_fontColorSelect option:selected`).last().data('color'));
          console.log($(this).parent().children(`#${that.id}_colorhex`).first()[0].value);

          try {
            var isHex = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(colorHex) // for #f00 (Thanks Smamatti)
            if (isHex) {
              editor.setTextColour(colorHex);
            } else {
              editor.setTextColour(selectedFontColor);
            }
          } catch (e) {
            console.log("Couldn't set text color with hex");
            console.log(e);
          } finally {
            $(this).parent().parent().removeClass('drop-open');
          }
        });
      });

      this.highlightColorDrop = new Drop({
        target: this.getElement(`${this.id}_setHighlightColour`),
        //target: $(`#${this.id}_setHighlightColour`).first()[0],
        content: $(`#${this.id}_drop-highlight-color`, this.rootElement).html(),
        position: 'bottom center',
        openOn: 'click'
      });

      this.highlightColorDrop.on('open', function () {
        //$(that.highlightColorDrop.content).parent().css('z-index', 9999);
        that.fixDropLocation(that.highlightColorDrop);
        $('.quit', this.rootElement).click(function () {
          $(this).parent().parent().removeClass('drop-open');
        });

        $('.submitHighlightColor', this.rootElement).unbind().click(function () {
          var highlightHex = $(this).parent().children(`#${that.id}_highlightHex`).first()[0].value;
          var selectedHighlightColor = $(`select#${that.id}_highlightColorSelect option:selected`).last().data('color');
          console.log($(`select#${that.id}_highlightColorSelect option:selected`).last().data('color'));
          console.log($(this).parent().children(`#${that.id}_highlightHex`).first()[0].value);

          try {
            var isHex = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(highlightHex) // for #f00 (Thanks Smamatti)
            if (isHex) {
              editor.setHighlightColour(highlightHex);
            } else {
              editor.setHighlightColour(selectedHighlightColor);
            }
          } catch (e) {
            console.log("Couldn't set text color with hex");
            console.log(e);
          } finally {
            $(this).parent().parent().removeClass('drop-open');
          }
        });
      });

      $('.item', this.rootElement).click(function () {
        console.log('item-click', 'action:',$(this).data('action'));
        var action = $(this).data('action');

        var test = {
          value: $(this).data('action'),
          testBold: editor.testPresenceinSelection('bold',
              action, 'B', (/>B\b/)),
          testItalic: editor.testPresenceinSelection('italic',
              action, 'I', (/>I\b/)),
          testUnderline: editor.testPresenceinSelection(
              'underline', action, 'U', (/>U\b/)),
          testRemoveAllFormatting: editor.testPresenceinSelection(
              'removeAllFormatting', action, 'R', (/>R\b/)),
          testOrderedList: editor.testPresenceinSelection(
              'makeOrderedList', action, 'OL', (/>OL\b/)),
          testUnorderedList: editor.testPresenceinSelection(
              'makeUnorderedList', action, 'UL', (/>UL\b/)),
          testLink: editor.testPresenceinSelection('makeLink',
              action, 'A', (/>A\b/)),
          testQuote: editor.testPresenceinSelection(
              'increaseQuoteLevel', action, 'blockquote', (
                  />blockquote\b/)),
          isNotValue: function (a) {
            return (a == action && this.value !== '');
          }
        };

        editor.alignRight = function () {
          editor.setTextAlignment('right');
        };
        editor.alignCenter = function () {
          editor.setTextAlignment('center');
        };
        editor.alignLeft = function () {
          editor.setTextAlignment('left');
        };
        editor.alignJustify = function () {
          editor.setTextAlignment('justify');
        };
        editor.makeHeading = function () {
          if(editor.headingSet) {
            editor.setFontSize('13px');
            editor.removeBold();
            editor.headingSet = false;
          }
          else {
            editor.setFontSize('2em');
            editor.bold();
            editor.headingSet = true;
          }

        };

        if (test.testBold | test.testItalic | test.testUnderline | test.testRemoveAllFormatting | test.testOrderedList | test.testUnorderedList | test.testLink | test.testQuote) {
          if (test.testBold) editor.removeBold();
          if (test.testItalic) editor.removeItalic();
          if (test.testUnderline) editor.removeUnderline();
          if (test.testRemoveAllFormatting) editor.removeAllFormatting();
          if (test.testLink) editor.removeLink();
          if (test.testOrderedList) editor.removeList();
          if (test.testUnorderedList) editor.removeList();
          if (test.testQuote) editor.decreaseQuoteLevel();
          //} else if (test.isNotValue('makeLink') | test.isNotValue('insertImage') | test.isNotValue('selectFont')) {
        } else if (test.isNotValue('makeLink') |  test.isNotValue('selectFont')) {
          // do nothing these are dropdowns.
        } else if (test.isNotValue('makeButton') ) {
          // do nothing these are dropdowns.
        }else if (test.isNotValue('makeFormItem') ) {
          // do nothing these are dropdowns.
        }else if (test.value === 'addAttachment') {
          that.addAttachment();
        } else if(test.value === 'upload') {
          that.uploadWebpage();
        }
        else if(test.value === 'insertImage') {
          that.uploadImage();
        } else {
          if(editor[action]) {
            editor[action]();
            editor.focus();
          }
        }
      });
    },
    fixDropLocation(dropObj) {
      console.log('fixDropLocation', 'dropObj:', dropObj);
      $(dropObj.drop).css('z-index', 100000);
      let transformElems = (new String(/^matrix\((.+)\)$/.exec($(dropObj.drop).css('transform'))[1])).split(',');
      console.log('fixDropLocation', 'transformElems:', transformElems);
      let targetRect = dropObj.target.getBoundingClientRect();
      let newY = targetRect.y + targetRect.height
      console.log('fixDropLocation', 'newY:', newY);
      transformElems[transformElems.length - 1] = newY;
      $(dropObj.drop).css('transform',`matrix(${transformElems.join(',')})`);
      console.log('fixDropLocation', 'css:', newY);
      $(dropObj.drop).addClass('drop-open');
    },
    async addAttachment() {
      if(this.byClient) {
        let attachmentViewportID = this.byClient.childViewports.showAttachments();
        await this.$nextTick();
        let attachmentViewport = window.devStore.viewPorts.find(e => e.viewportID === attachmentViewportID);
        if(attachmentViewport) {
          let id = oxygenUtil.getUUID();
          attachmentViewport.instance.addRowSelectedCallback(id, (dataRow, index)=>{
            this.insertAttachmentLink(dataRow);
            attachmentViewport.instance.removeRowSelectedCallback(id);
          })
        }
      }
    },
    insertAttachmentLink(dataRow) {
      let parsedCurrentAttachmentPE = oxygenUtil.parseOES(dataRow.data.GrantPE).segments;

      this.editor.makeOxygenLink(
          dataRow.data.GrantRightDN,
          {
            "data-PE": oxygenUtil.createSimpleOES(['bot', this.client.ClientRight, parsedCurrentAttachmentPE[2], parsedCurrentAttachmentPE[3]]),
            "class": "grant-link"
          }
      );

    },
    setContent(content) {
      this.editor.setHTML(content);
    },
    getContent(callback) {
      //this.convertLinks(this.editor.getHTML(), callback);
      this.convertLinks(this.editor.getDocument().documentElement.innerHTML, callback);
    },
    convertLinks(content, callback) {
      let regex = /<a\s+href="javascript:\s+void\(0\)"\s+data-pe="([^"]+)"\s+class="grant-link">([^<]+)<\/a>/g;
      let matches, newContent = content;

      async.whilst(
          (callback) =>{
            callback(null, matches = regex.exec(content));
          },
          (callback) => {
            let embeddingData = this.createGenericAttachmentData({});
            let parsedGrantPE = oxygenUtil.parseOES(this.GrantPE).segments;
            let parsedAttachmentPE = oxygenUtil.parseOES(matches[1]).segments;
            this.putGrant({
              onObject: parsedAttachmentPE[3],
              onRole: parsedAttachmentPE[2],
              toPE: oxygenUtil.createSimpleOES(['bot', this.atComponent.Node, parsedGrantPE[2], parsedGrantPE[3]]),
              fromPE: this.FromPE,
              fromGrantId: this.fromGrantId,
              byPE: this.getComponentGrantPE(),
              byGrantId: this.getComponentGrantID(),
              ArgJSON: { embeddingData }
            }, (error, grant)=>{
              if(error) {
                return callback(error);
              }
              newContent = newContent.replace(matches[0], `<a href="javascript: void(0)" data-pe="${grant.GrantPE}" class="${this.config.htmlIds.grantLinkClass}">${matches[2]}</a>`);
              callback();
            });
          },
          function(error){
            callback(error, newContent);
          }
      );
    }
  },
  watch: {
    'viewport.Width': {
      immediate: true,
      handler: function(newVal) {
        console.log('watch-viewport.Width', 'newVal:', newVal);
        //this.parent.debugLog('watch-breakpoint', 'breakpoint:', newVal);
        /*
        if(newVal === '415px') {
          this.ribbonItems.find(e => (e.id === 'expand')).show = true;
          this.ribbonItems.find(e => (e.id === 'collapse')).show = false;
          this.headerStyleObj.height = '39px';
        }
        else {
          this.ribbonItems.find(e => (e.id === 'expand')).show = false;
          this.ribbonItems.find(e => (e.id === 'collapse')).show = false;
          this.headerStyleObj.height = '39px';
        }

         */
      }
    }
  }
}
</script>

<style>
/*@import url('/simplia/dist/css/all.css');*/
/*.header {
    padding: 50px 0 30px;
    color: #fff;
    text-align: center;
    background: #1d193d;
    margin-bottom: 20px;
}*/

.header h1 {
  font-size: 8em;
  line-height: 1em;
  font-weight: 900;
}

.header h2 {
  margin-bottom: 1em;
  font-size: 3em;
  font-weight: 300;
  text-transform: lowercase;
  color: #afaedf;
}

.col-centered{
  float: none;
  margin: 0 auto;
  width: 80%;
}

.alignCenter {
  text-align: center;
}

iframe {
  width: 100%;
  border: 1px #919191 solid;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  /*padding: 7px 8px;*/
  color: #333;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: right center;
  border: 1px solid #ccc;
  border-radius: 3px;
  outline: none;
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.075);
}

.menu .item {
  float:left;
  padding-left:8px;
  /*color:#000;*/
  /*background:#FFF;*/
  /*border-left:1px #EEE solid;*/
  /*border-bottom: 3px transparent solid;*/
  /*-webkit-font-smoothing:subpixel-antialiased*/
}

.menu .group {
  border-radius:3px;
  display:inline-block;
  /*border:1px #EEE solid;*/
  margin-left: 10px
}

.menu .group .item .flip {
  -ms-transform:rotateY(180deg);
  -webkit-transform:rotateY(180deg);
  -moz-transform:rotateY(180deg);
  transform:rotateY(180deg)
}
/*
.btn {
    background: #516066;
    display: block;
    position: relative;
    padding: 10px 15px;
    margin-top: 10px;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 500;
    color: #fff;
    text-align: center;
    overflow: hidden;
    letter-spacing: 1px;
    border-radius: 4px;
}


input[type=text] {
    background-color: #fff;
    vertical-align: middle;
    max-width: 100%;
    border: 1px solid #a8afb2;
    border-color: #a8afb2 #d4d7d9 #d4d7d9;
    color: #516066;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: border linear 150ms;
    -moz-transition: border linear 150ms;
    -o-transition: border linear 150ms;
    transition: border linear 150ms;
    font-size: 14px;
    padding: 5px;
    width: 100%;
}
*/

.menu .group .item:hover, .menu .item:first-child:hover {
  /*border-bottom: 3px #55ACEE solid;*/
  color: #0072c5;
}

.menu .item:first-child {
  border-left:none;
}

.menu {
  max-height: 22px;
  text-align: left;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.drop {
  border: 1px solid #dbdbdb;
  padding: 14px;
  background: white;
  box-shadow: 0 1px 0 rgba(255,255,255,0),0 0 10px rgba(0,0,0,0.1);
  -webkit-border-radius: 4px;
  border-radius: 4px;
  margin-top: 5px;
}

.hidden {
  display: none;
}

.quit {
  float: right;
  top:0;
  right:0;
  margin-bottom: 5px;
}
.drop-element, .drop-element:after, .drop-element:before, .drop-element *, .drop-element *:after, .drop-element *:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box; }

.drop-element {
  position: absolute;
  display: none; }
.drop-element.drop-open {
  display: block; }

.drop-element.drop-theme-arrows {
  max-width: 100%;
  max-height: 100%; }
.drop-element.drop-theme-arrows .drop-content {
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  border-radius: 5px;
  position: relative;
  font-family: inherit;
  background: #eeeeee;
  color: #444444;
  padding: 1em;
  font-size: 1.1em;
  line-height: 1.5em;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));
  -moz-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));
  filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); }
.drop-element.drop-theme-arrows .drop-content:before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-width: 16px;
  border-style: solid; }
.drop-element.drop-theme-arrows.drop-element-attached-bottom.drop-element-attached-center .drop-content {
  margin-bottom: 16px; }
.drop-element.drop-theme-arrows.drop-element-attached-bottom.drop-element-attached-center .drop-content:before {
  top: 100%;
  left: 50%;
  margin-left: -16px;
  border-top-color: #eeeeee; }
.drop-element.drop-theme-arrows.drop-element-attached-top.drop-element-attached-center .drop-content {
  margin-top: 16px; }
.drop-element.drop-theme-arrows.drop-element-attached-top.drop-element-attached-center .drop-content:before {
  bottom: 100%;
  left: 50%;
  margin-left: -16px;
  border-bottom-color: #eeeeee; }
.drop-element.drop-theme-arrows.drop-element-attached-right.drop-element-attached-middle .drop-content {
  margin-right: 16px; }
.drop-element.drop-theme-arrows.drop-element-attached-right.drop-element-attached-middle .drop-content:before {
  left: 100%;
  top: 50%;
  margin-top: -16px;
  border-left-color: #eeeeee; }
.drop-element.drop-theme-arrows.drop-element-attached-left.drop-element-attached-middle .drop-content {
  margin-left: 16px; }
.drop-element.drop-theme-arrows.drop-element-attached-left.drop-element-attached-middle .drop-content:before {
  right: 100%;
  top: 50%;
  margin-top: -16px;
  border-right-color: #eeeeee; }
.drop-element.drop-theme-arrows.drop-element-attached-top.drop-element-attached-left.drop-target-attached-bottom .drop-content {
  margin-top: 16px; }
.drop-element.drop-theme-arrows.drop-element-attached-top.drop-element-attached-left.drop-target-attached-bottom .drop-content:before {
  bottom: 100%;
  left: 16px;
  border-bottom-color: #eeeeee; }
.drop-element.drop-theme-arrows.drop-element-attached-top.drop-element-attached-right.drop-target-attached-bottom .drop-content {
  margin-top: 16px; }
.drop-element.drop-theme-arrows.drop-element-attached-top.drop-element-attached-right.drop-target-attached-bottom .drop-content:before {
  bottom: 100%;
  right: 16px;
  border-bottom-color: #eeeeee; }
.drop-element.drop-theme-arrows.drop-element-attached-bottom.drop-element-attached-left.drop-target-attached-top .drop-content {
  margin-bottom: 16px; }
.drop-element.drop-theme-arrows.drop-element-attached-bottom.drop-element-attached-left.drop-target-attached-top .drop-content:before {
  top: 100%;
  left: 16px;
  border-top-color: #eeeeee; }
.drop-element.drop-theme-arrows.drop-element-attached-bottom.drop-element-attached-right.drop-target-attached-top .drop-content {
  margin-bottom: 16px; }
.drop-element.drop-theme-arrows.drop-element-attached-bottom.drop-element-attached-right.drop-target-attached-top .drop-content:before {
  top: 100%;
  right: 16px;
  border-top-color: #eeeeee; }
.drop-element.drop-theme-arrows.drop-element-attached-top.drop-element-attached-right.drop-target-attached-left .drop-content {
  margin-right: 16px; }
.drop-element.drop-theme-arrows.drop-element-attached-top.drop-element-attached-right.drop-target-attached-left .drop-content:before {
  top: 16px;
  left: 100%;
  border-left-color: #eeeeee; }
.drop-element.drop-theme-arrows.drop-element-attached-top.drop-element-attached-left.drop-target-attached-right .drop-content {
  margin-left: 16px; }
.drop-element.drop-theme-arrows.drop-element-attached-top.drop-element-attached-left.drop-target-attached-right .drop-content:before {
  top: 16px;
  right: 100%;
  border-right-color: #eeeeee; }
.drop-element.drop-theme-arrows.drop-element-attached-bottom.drop-element-attached-right.drop-target-attached-left .drop-content {
  margin-right: 16px; }
.drop-element.drop-theme-arrows.drop-element-attached-bottom.drop-element-attached-right.drop-target-attached-left .drop-content:before {
  bottom: 16px;
  left: 100%;
  border-left-color: #eeeeee; }
.drop-element.drop-theme-arrows.drop-element-attached-bottom.drop-element-attached-left.drop-target-attached-right .drop-content {
  margin-left: 16px; }
.drop-element.drop-theme-arrows.drop-element-attached-bottom.drop-element-attached-left.drop-target-attached-right .drop-content:before {
  bottom: 16px;
  right: 100%;
  border-right-color: #eeeeee; }




option:after {
  content: " ";
  height: 5px;
  width: 5px;
  border-radius: 5px;
  display: inline-block;
}

option.red{ background: #c00; }
option.green{ background: #0c0; }
option.blue{ background: #00c; }

.header-title-ribbon { background: white; color: #0072C5; display: flex; /*height: 21px;*/  }
.ribbon-left {
  display: flex;
  overflow: hidden;
  align-items: flex-start;
  flex-wrap: wrap;
  overflow: hidden;
  flex-grow: 1;
}

.ribbon-icon { cursor: pointer; }
.ribbon-icon-left { padding: 9px 12px; }
.ribbon-icon-right { padding: 9px 12px;  }

.clicked-button {
  color: red;
}

.ribbon-right {
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
}

.grayout {
  opacity: 0.6; /* Real browsers */
  filter: alpha(opacity = 60); /* MSIE */
  cursor: default;
}

.blinking {
  animation: blinker 1s linear infinite;
}

.bold-icon {
  -webkit-text-stroke: 3px inherit;
}

.dhx_button--view_flat.dhx_button--color_primary {
  background-color: #0072C5;
  outline-width: 0;
}

.dhx_button--view_flat {
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  font-family: Roboto,Arial,Tahoma,Verdana,sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  color: #fff;
  -webkit-transition: background-color .2s ease-in,color .2s ease-in,box-shadow .2s ease-in;
  transition: background-color .2s ease-in,color .2s ease-in,box-shadow .2s ease-in;
}

.dhx_button--size_medium {
  padding: 6px 16px;
  text-transform: uppercase;
  line-height: 20px;
}

.dhx_button {
  overflow: visible;
  position: relative;
  text-decoration: none;
  background-image: none;
  border: 0;
  touch-action: manipulation;
  -webkit-appearance: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  cursor: pointer;
}

.dhx_button--view_flat {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Roboto,Arial,Tahoma,Verdana,sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  color: #fff;
  transition: background-color .2s ease-in,color .2s ease-in,box-shadow .2s ease-in;
}
</style>
